'use client';

import { useSuspenseQuery } from '@tanstack/react-query';
import { BANNER_QUERIES } from '../../infrastructure/banner/utils/queries';
import type { GetBannersRequest } from '../../infrastructure/banner/utils/types';

export const useBannerService = () => {
  const useGetBanners = (params: GetBannersRequest = { location: '/' }) => {
    return useSuspenseQuery(BANNER_QUERIES.getBanners(params));
  };

  return {
    useGetBanners,
  };
};
